import React from 'react';
import PropTypes from 'prop-types';

import styled from 'styled-components';

import { exercisePropTypes, HIGHLIGHT_SUCCESS, HIGHLIGHT_ERROR } from '../../../constants/exercise';
import Checkbox from '../../check-box-group/check-box';
import { getCharByElementPosition } from '../../../lib/exercise';
import MathContent from '../../math-content';

const BoxContainer = styled.div`
    width: fit-content;
`;

const SingleAnswerContainer = styled.div`
    display: flex;
    font-size: 16px;
    padding-right: 32px;
`;

const SingleFeedbackContainer = styled.div`
    margin-top: 8px;
`;

const SingleFeedback = styled.span`
    font-size: 16px;
`;

const SingleFeedbackLabel = styled.span`
    font-size: 16px;
    font-weight: 600;
`;

const Index = styled.div`
    font-size: 16px;
    font-weight: 600;
    padding: 9px 16px 0 0;
`;

const AnswersContainer = styled.div`
    margin: 24px 0 16px 0;

    & > div:not(:first-child) {
        margin-top: 16px;
    }
`;

export function getFeedbackTypes(answers, options) {
    let answersWithType = [];
    const correctOptionsIds = options.filter((item) => item.correct === true).map((item) => item.id);
    const selectedOptionsIds = answers.map((item) => parseInt(item));

    selectedOptionsIds.map((item) => !correctOptionsIds.includes(item) && answersWithType.push({ id: item, type: 'wrong' }));
    correctOptionsIds.map((item) =>
        selectedOptionsIds.includes(item)
            ? answersWithType.push({ id: item, type: 'correct' })
            : answersWithType.push({ id: item, type: 'missing' }),
    );

    return answersWithType;
}

export const SingleMultipleChoiceFeedback = ({ answerType, feedback, index, text }) => {
    return (
        <SingleAnswerContainer key={index}>
            <Index>{`${getCharByElementPosition(index + 1)}.`}</Index>
            <div>
                <BoxContainer>
                    <Checkbox
                        disabled={true}
                        highlight={answerType === 'correct' || answerType === 'missing' ? HIGHLIGHT_SUCCESS : HIGHLIGHT_ERROR}
                        selected={answerType === 'correct' ? true : false}
                        value={index}
                    >
                        {text}
                    </Checkbox>
                </BoxContainer>
                <SingleFeedbackContainer>
                    <SingleFeedbackLabel>
                        {answerType === 'correct'
                            ? 'Risposta esatta. '
                            : answerType === 'wrong'
                              ? 'Risposta sbagliata. '
                              : 'Risposta non data. '}
                    </SingleFeedbackLabel>
                    {feedback && (
                        <SingleFeedback>
                            <MathContent style={{ display: 'inline' }}>{feedback}</MathContent>
                        </SingleFeedback>
                    )}
                </SingleFeedbackContainer>
            </div>
        </SingleAnswerContainer>
    );
};
SingleMultipleChoiceFeedback.propTypes = {
    answerType: PropTypes.string,
    feedback: PropTypes.string,
    index: PropTypes.number,
    text: PropTypes.string,
};

const MultipleChoiceFeedback = ({ answers, exercise }) => {
    const selectedAnswers = getFeedbackTypes(answers, exercise.options);
    return (
        <AnswersContainer>
            {exercise.options.map((option, index) => {
                const currentOption = selectedAnswers.find((item) => item.id === option.id);
                return (
                    currentOption && (
                        <SingleMultipleChoiceFeedback
                            key={index}
                            answerType={currentOption.type}
                            text={option.text}
                            feedback={option.feedback}
                            index={index}
                        />
                    )
                );
            })}
        </AnswersContainer>
    );
};
MultipleChoiceFeedback.propTypes = exercisePropTypes.propTypes;

export default MultipleChoiceFeedback;
